.baseForm {
  max-height: var(--baseForm-max-height);
  max-width: var(--baseForm-max-width);
  height: var(--baseForm-height);
  width: var(--baseForm-width);
}
